<portal-sub-nav route="end-user">
  <div [class.d-none]="loading === true">
    @if (user$ | async; as user) {
      <portal-menu-context
        [description]="user | contactName"
        [heading]="'menu.context.endUser' | portalTranslate"
      >
        <ng-template>
          <portal-end-user-switcher></portal-end-user-switcher>
        </ng-template>
        @if (canUseRichPresence$ | async) {
          <portal-rich-presence-state
            class="end-user-sub-nav__rich-presence-state"
            *portalTransclude="'afterDescription'"
            dropdownPlacement="bottom-start"
          ></portal-rich-presence-state>
        }
      </portal-menu-context>
    }

    <!-- Personalization -->
    <portal-sub-nav-item
      *portalIsAuthorized="{
        anyPermission: [Permission.VIEW_PAGE_GENERAL],
      }"
      route="end-user-personalization"
    >
      <span *portalTransclude>{{ 'menu.end-user-personalization' | portalTranslate }}</span>
    </portal-sub-nav-item>

    <!-- Permissions -->
    <portal-sub-nav-item route="end-user-permissions">
      <span *portalTransclude>{{ 'menu.end-user-permissions' | portalTranslate }}</span>
    </portal-sub-nav-item>

    <!-- Phone Numbers -->
    <portal-sub-nav-item route="end-user-phone-numbers">
      <span *portalTransclude>{{ 'menu.phoneNumbers' | portalTranslate }}</span>
    </portal-sub-nav-item>

    <!-- Devices -->
    @if (hasDevice$ | async) {
      <portal-sub-nav-item
        *portalIsAuthorized="{
          anyPermission: [Permission.VIEW_DEVICES],
        }"
        route="end-user-devices"
      >
        <span *portalTransclude>{{ 'menu.devices' | portalTranslate }}</span>
      </portal-sub-nav-item>
    }

    <!-- Features -->
    <portal-sub-nav-item route="end-user-features">
      <span *portalTransclude>{{ 'menu.features' | portalTranslate }}</span>
    </portal-sub-nav-item>

    <!-- Time Tables -->
    <portal-sub-nav-item route="end-user-time-table">
      <span *portalTransclude>{{ 'menu.timeTable' | portalTranslate }}</span>
    </portal-sub-nav-item>

    <!-- IP Filter -->
    @if (hasDevice$ | async) {
      <portal-sub-nav-item
        *portalIsAuthorized="{
          anyPermission: [Permission.VIEW_IPFILTER],
        }"
        route="end-user-ipfilter"
      >
        <span *portalTransclude>{{ 'menu.ipFilter' | portalTranslate }}</span>
      </portal-sub-nav-item>
    }

    <!-- Call Barring -->
    <portal-sub-nav-item
      *portalIsAuthorized="{
        anyPermission: [Permission.VIEW_USER_ACL],
      }"
      route="end-user-call-barring"
    >
      <span *portalTransclude>{{ 'menu.callBarring' | portalTranslate }}</span>
    </portal-sub-nav-item>

    <!-- Rich presence profiles -->
    @if (canUseRichPresence$ | async) {
      <portal-sub-nav-item
        *portalIsAuthorized="{
          anyPermission: [Permission.VIEW_PRESENCE_PROFILE],
        }"
        route="end-user-rich-presence-profiles"
      >
        <span *portalTransclude>{{ 'menu.richPresenceProfiles' | portalTranslate }}</span>
      </portal-sub-nav-item>
    }

    <!-- Teams presence sync -->
    @if (hasMs365Presence$ | async) {
      <portal-sub-nav-item route="end-user-ms365-presence">
        <span *portalTransclude>{{ 'menu.ms365Presence' | portalTranslate }}</span>
      </portal-sub-nav-item>
    }

    <!-- Call logs -->
    <portal-sub-nav-item
      *portalIsAuthorized="{
        allPermissions: [Permission.VIEW_USER_CALL_LOG],
      }"
      route="end-user-call-logs"
    >
      <span *portalTransclude>{{ 'menu.callLogs' | translate }}</span>
    </portal-sub-nav-item>
  </div>

  @if (loading) {
    <portal-menu-loading-indicator [withContext]="true"></portal-menu-loading-indicator>
  }
</portal-sub-nav>
